import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Input } from "reactstrap";

/** value shape: { kind: 'days'|'months', amount: number } */
const DURATION_OPTIONS = [
  { kind: "days", amount: 7, label: "7 days (free trial)" },
  { kind: "days", amount: 14, label: "14 days (free trial)" },
  { kind: "months", amount: 1, label: "1 month" },
  { kind: "months", amount: 2, label: "2 months" },
  { kind: "months", amount: 3, label: "3 months" },
  { kind: "months", amount: 6, label: "6 months" },
  { kind: "months", amount: 12, label: "12 months" },
];

const ActivateAiTransferModal = ({ isOpen, toggle, parentLabel, loading, onSubmit }) => {
  const [selected, setSelected] = useState("days:7");

  useEffect(() => {
    if (isOpen) setSelected("days:7");
  }, [isOpen]);

  const handleActivate = () => {
    const [kind, amountStr] = String(selected).split(":");
    const amount = Number(amountStr);
    if (kind === "days") {
      onSubmit?.({ days: amount });
    } else {
      onSubmit?.({ months: amount });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Activate AI by transfer</ModalHeader>
      <ModalBody>
        <div className="mb-2 text-muted small">
          {parentLabel ? `Parent: ${parentLabel}` : "Select duration and activate access."}
        </div>
        <Label className="form-label">Activation duration</Label>
        <Input
          type="select"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        >
          {DURATION_OPTIONS.map((opt) => (
            <option key={`${opt.kind}:${opt.amount}`} value={`${opt.kind}:${opt.amount}`}>
              {opt.label}
            </option>
          ))}
        </Input>
        <small className="text-muted d-block mt-2">
          Free-trial options grant day-based access. Month options match paid plan lengths.
        </small>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-light" onClick={toggle} disabled={loading}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleActivate}
          disabled={loading}
        >
          {loading ? "Activating..." : "Activate"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ActivateAiTransferModal;
